export default __webpack_public_path__ + "static/O0248-8feafd8d829e0d154aab3069d66fd261.png";